// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { isEqual as fn } from "../isEqual.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const isEqual = convertToFP(fn, 2);

// Fallback for modularized imports:
export default isEqual;
